/**
 * Multi-Location Inventory Toggle Functionality
 * Maneja el despliegue/colapso del widget Multi-Location Inv
 */

class MultiLocationToggle {
  constructor() {
    this.isOpen = false;
    this.detailsContainer = null;
    this.mutationObserver = null;
    this.toggleButton = null;
    this.isInitialized = false;
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupToggle());
    } else {
      this.setupToggle();
    }
  }

  setupToggle() {
    this.setupGlobalObserver();

    this.attemptInitialization();
  }

  setupGlobalObserver() {
    if (this.mutationObserver) return;
    this.mutationObserver = new MutationObserver((mutations) => {
      let shouldReinitialize = false;

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (
                node.querySelector &&
                (node.querySelector('.iia-header-container') ||
                  node.querySelector('.iia-details-container') ||
                  node.classList.contains('iia-header-container') ||
                  node.classList.contains('iia-details-container'))
              ) {
                shouldReinitialize = true;
                // Hide native header immediately to avoid flash before we sync our toggle
                const header = document.querySelector('.iia-header-container');
                if (header) header.style.display = 'none';
              }
            }
          });
        }
      });

      if (shouldReinitialize) {
        setTimeout(() => this.attemptInitialization(), 100);
      }
    });

    this.mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  attemptInitialization() {
    const headerContainer = document.querySelector('.iia-header-container');

    if (!headerContainer) {
      return;
    }

    if (document.querySelector('.iia-toggle-button')) {
      this.syncState();
      return;
    }

    this.createToggleButton(headerContainer);

    this.applyState(false);
    this.isInitialized = true;
  }

  syncState() {
    this.detailsContainer = document.querySelector('.iia-details-container');
    if (this.detailsContainer) {
      this.detailsContainer.classList.toggle('is-open', this.isOpen);
    }

    const arrow = document.querySelector('.iia-toggle-arrow svg');
    if (arrow) {
      arrow.style.transform = this.isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
    }

    const headerContainer = document.querySelector('.iia-header-container');
    if (headerContainer) headerContainer.style.display = 'none';
  }

  createToggleButton(headerContainer) {
    const toggleButton = document.createElement('button');
    toggleButton.className = 'iia-toggle-button';
    toggleButton.setAttribute('type', 'button');
    toggleButton.setAttribute('aria-expanded', 'false');
    toggleButton.innerHTML = `
      <svg class="iia-toggle-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
        <path d="M14.1736 5.79953V12.0632C14.1736 12.4242 14.0527 12.7255 13.8109 12.9673C13.5692 13.2091 13.2679 13.33 12.9071 13.33H2.11031C1.74936 13.33 1.44799 13.2091 1.20622 12.9673C0.964449 12.7255 0.843569 12.4242 0.843569 12.0632V5.76934C0.512799 5.52508 0.270769 5.2049 0.117475 4.80879C-0.0358202 4.41268 -0.0390871 3.98998 0.107674 3.54068L0.870819 1.02543C0.975369 0.70577 1.14395 0.45491 1.37657 0.27287C1.60933 0.0909499 1.8971 0 2.23989 0H12.7471C13.0899 0 13.3769 0.0851999 13.6081 0.25562C13.8394 0.42603 14.0088 0.67257 14.1164 0.99524L14.9095 3.54068C15.0563 3.98998 15.053 4.41621 14.8997 4.81938C14.7464 5.22242 14.5044 5.54913 14.1736 5.79953ZM9.23367 5.48882C9.73727 5.48882 10.1133 5.34781 10.3616 5.06579C10.6099 4.7839 10.7145 4.49266 10.6753 4.19208L10.1534 0.78411H7.90063V4.07741C7.90063 4.46241 8.03229 4.79389 8.29563 5.07186C8.55909 5.34983 8.87176 5.48882 9.23367 5.48882ZM5.7051 5.48882C6.1263 5.48882 6.46687 5.34983 6.7268 5.07186C6.98661 4.79389 7.11651 4.46241 7.11651 4.07741V0.78411H4.86374L4.34191 4.25227C4.30976 4.4956 4.41607 4.76253 4.66085 5.05305C4.90563 5.34356 5.25371 5.48882 5.7051 5.48882ZM2.21577 5.48882C2.56157 5.48882 2.85535 5.3712 3.09712 5.13597C3.33889 4.90073 3.48944 4.60721 3.54878 4.2554L4.04042 0.78411H2.23989C2.06895 0.78411 1.93323 0.82182 1.83273 0.89722C1.73224 0.97263 1.65683 1.08574 1.60652 1.23655L0.882769 3.7124C0.754049 4.12459 0.809069 4.5237 1.04783 4.90975C1.2866 5.2958 1.67591 5.48882 2.21577 5.48882ZM12.8014 5.48882C13.2708 5.48882 13.6458 5.30586 13.9264 4.93994C14.2069 4.57402 14.2762 4.16484 14.1344 3.7124L13.3714 1.20636C13.3211 1.05555 13.2457 0.94747 13.1452 0.88213C13.0447 0.81679 12.909 0.78411 12.7381 0.78411H10.9768L11.4684 4.2554C11.5277 4.60721 11.6783 4.90073 11.92 5.13597C12.1618 5.3712 12.4556 5.48882 12.8014 5.48882ZM2.11031 12.5458H12.9071C13.0477 12.5458 13.1633 12.5006 13.2538 12.4102C13.3443 12.3196 13.3895 12.204 13.3895 12.0632V6.17335C13.2839 6.20955 13.1836 6.23523 13.0886 6.25039C12.9937 6.26542 12.898 6.27294 12.8014 6.27294C12.4485 6.27294 12.1382 6.20407 11.8703 6.06632C11.6023 5.92858 11.3478 5.70896 11.1065 5.40747C10.9015 5.6627 10.6487 5.87075 10.3481 6.03162C10.0475 6.1925 9.68197 6.27294 9.25167 6.27294C8.93906 6.27294 8.64175 6.20008 8.35973 6.05436C8.07784 5.90852 7.79412 5.69289 7.50857 5.40747C7.24615 5.69289 6.95537 5.90852 6.63624 6.05436C6.3171 6.20008 6.01273 6.27294 5.72313 6.27294C5.39446 6.27294 5.07408 6.21008 4.762 6.08436C4.44979 5.95877 4.17607 5.73314 3.94083 5.40747C3.55583 5.79247 3.21931 6.03293 2.93128 6.12886C2.64325 6.22491 2.40475 6.27294 2.21577 6.27294C2.11933 6.27294 2.0221 6.26542 1.92408 6.25039C1.82607 6.23523 1.72727 6.20955 1.62769 6.17335V12.0632C1.62769 12.204 1.6729 12.3196 1.76334 12.4102C1.8539 12.5006 1.96956 12.5458 2.11031 12.5458Z" fill="black"/>
      </svg>
      <span class="iia-toggle-text">${this.getTranslatedText()}</span>
      <span class="iia-toggle-arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m6 9l6 6l6-6"/>
        </svg>
      </span>
    `;

    // Prevent initial flash: hide until state applied
    toggleButton.style.visibility = 'hidden';

    headerContainer.parentNode.insertBefore(toggleButton, headerContainer.nextSibling);

    toggleButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.applyState(!this.isOpen);
    });

    this.toggleButton = toggleButton;

    // Temporarily disable transitions on inner elements to avoid flicker
    const icon = this.toggleButton.querySelector('.iia-toggle-icon');
    const text = this.toggleButton.querySelector('.iia-toggle-text');
    const restoreTransitions = [];
    [icon, text].forEach((el) => {
      if (!el) return;
      restoreTransitions.push({ el, prev: el.style.transition });
      el.style.transition = 'none';
    });

    // Restore transitions in next frame after styles are settled
    requestAnimationFrame(() => {
      restoreTransitions.forEach(({ el, prev }) => {
        el.style.transition = prev || '';
      });
    });
  }

  applyState(open) {
    this.isOpen = !!open;

    this.detailsContainer = document.querySelector('.iia-details-container');
    if (this.detailsContainer) {
      this.detailsContainer.classList.toggle('is-open', this.isOpen);
    }

    this.toggleButton = document.querySelector('.iia-toggle-button');

    const arrow = this.toggleButton?.querySelector('.iia-toggle-arrow svg');
    if (arrow) {
      arrow.style.transform = this.isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
    }
    if (this.toggleButton) {
      this.toggleButton.setAttribute('aria-expanded', String(this.isOpen));
    }

    const headerContainer = document.querySelector('.iia-header-container');
    if (headerContainer) headerContainer.style.display = 'none';

    // Reveal toggle after state and styles are applied to avoid flash
    if (this.toggleButton) {
      requestAnimationFrame(() => {
        this.toggleButton.style.visibility = '';
      });
    }
  }

  getTranslatedText() {
    if (window.Shopify && window.Shopify.locale) {
      const locale = window.Shopify.locale;

      // Mapeo de idiomas
      const translations = {
        es: 'BUSCAR EN TIENDA',
        en: 'SEARCH IN STORE',
        fr: 'RECHERCHER EN MAGASIN',
      };

      return translations[locale] || translations['en'];
    }

    const browserLang = navigator.language || navigator.userLanguage;
    const langCode = browserLang.split('-')[0];

    const translations = {
      es: 'BUSCAR EN TIENDA',
      en: 'SEARCH IN STORE',
      fr: 'RECHERCHER EN MAGASIN',
    };

    return translations[langCode] || translations['en'];
  }
}

new MultiLocationToggle();
